import { PageHero } from "../components/PageHero";
import { BRAND } from "../data/content";
import { usePageMeta } from "../hooks/use-page-meta";

const LegalBody = ({ children, testid }) => (
  <section className="container-x py-16 sm:py-24" data-testid={testid}>
    <div className="max-w-3xl space-y-8 text-sm leading-relaxed text-steel sm:text-base">{children}</div>
  </section>
);

const H = ({ children }) => <h2 className="font-serif text-xl font-medium text-ivory sm:text-2xl">{children}</h2>;

export function Privacy() {
  usePageMeta("Privacy Policy | Celebrity Bouncers", "How Celebrity Bouncers collects, uses and protects your information.");
  return (
    <>
      <PageHero testid="privacy-page-hero" eyebrow="Legal" title="Privacy Policy" description="Effective for CelebrityBouncers.com" />
      <LegalBody testid="privacy-page-body">
        <div>
          <H>Information We Collect</H>
          <p className="mt-3">
            When you submit an enquiry, we collect the details you provide — your name, mobile
            number, event details and requirements — solely to respond to your enquiry and plan the
            requested service.
          </p>
        </div>
        <div>
          <H>How We Use It</H>
          <p className="mt-3">
            Enquiry details are shared only with our coordination team via secure email and are never
            published, sold or shared with third parties for marketing. Event details, guest
            information and movement plans are treated as confidential.
          </p>
        </div>
        <div>
          <H>Analytics & Cookies</H>
          <p className="mt-3">
            With your consent, we may use privacy-respecting analytics to understand website usage.
            You can decline non-essential storage through the consent banner.
          </p>
        </div>
        <div>
          <H>Your Choices</H>
          <p className="mt-3">
            To request access, correction or deletion of your enquiry details, email us at{" "}
            <a href={`mailto:${BRAND.email}`} className="text-gold underline underline-offset-2">{BRAND.email}</a>{" "}
            or call {BRAND.phonePrimary}.
          </p>
        </div>
      </LegalBody>
    </>
  );
}

export function Terms() {
  usePageMeta("Terms of Use | Celebrity Bouncers", "Terms governing the use of CelebrityBouncers.com.");
  return (
    <>
      <PageHero testid="terms-page-hero" eyebrow="Legal" title="Terms of Use" description="Effective for CelebrityBouncers.com" />
      <LegalBody testid="terms-page-body">
        <div>
          <H>Use of This Website</H>
          <p className="mt-3">
            This website provides information about the event security and hospitality support
            services of Celebrity Bouncers. Content may not be copied or republished without
            written permission.
          </p>
        </div>
        <div>
          <H>Enquiries & Quotations</H>
          <p className="mt-3">
            Submitting an enquiry does not create a service agreement. Deployments are confirmed
            only after consultation, assessment and a mutually agreed written quotation.
          </p>
        </div>
        <div>
          <H>Accuracy of Information</H>
          <p className="mt-3">
            We describe our services factually and avoid unverifiable claims. Where sample imagery
            or placeholder content is shown, it is clearly labelled as such.
          </p>
        </div>
        <div>
          <H>Contact</H>
          <p className="mt-3">
            Questions about these terms: <a href={`mailto:${BRAND.email}`} className="text-gold underline underline-offset-2">{BRAND.email}</a>.
          </p>
        </div>
      </LegalBody>
    </>
  );
}

export function Disclaimer() {
  usePageMeta("Disclaimer | Celebrity Bouncers", "Important notices regarding CelebrityBouncers.com content.");
  return (
    <>
      <PageHero testid="disclaimer-page-hero" eyebrow="Legal" title="Disclaimer" description="Effective for CelebrityBouncers.com" />
      <LegalBody testid="disclaimer-page-body">
        <div>
          <H>Imagery & Portfolio</H>
          <p className="mt-3">
            Unless otherwise stated, photographs on this website are licensed stock imagery used
            representatively. They do not depict our clients, their guests or specific past events.
            Real client events are published only with written permission.
          </p>
        </div>
        <div>
          <H>No Guarantees</H>
          <p className="mt-3">
            Our services are planned and delivered professionally, but no security service can
            eliminate all risk. We do not claim "zero risk" or "100% security", and descriptions on
            this site should not be read as such.
          </p>
        </div>
        <div>
          <H>External Links</H>
          <p className="mt-3">
            Links to WhatsApp, map services or email open third-party applications governed by their
            own terms and privacy policies.
          </p>
        </div>
        <div>
          <H>Service Area</H>
          <p className="mt-3">
            Services are offered across Andhra Pradesh and Telangana, subject to availability and
            confirmation for each event.
          </p>
        </div>
      </LegalBody>
    </>
  );
}
